export default __webpack_public_path__ + "static/media/Img_FindYourJoy_03.52afcd6a.png";